import { createRoot } from "react-dom/client";
import {
  ProjectsPage,
  type ProjectsPageProps,
} from "../../../react/code_app/projects/ProjectsPage";

document.addEventListener("DOMContentLoaded", () => {
  const targetContainer = document.querySelector("#js-react-root-projects")!;
  const reactRoot = createRoot(targetContainer);
  const serverRenderingProps = JSON.parse(
    targetContainer.getAttribute("data-json")!
  ) as ProjectsPageProps;

  reactRoot.render(<ProjectsPage {...serverRenderingProps} />);
});
